/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKnowledgeHubSetupType from '@jira/spa-apps__servicedesk-knowledge-hub-setup/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubSetup: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskKnowledgeHubSetupType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-knowledge-hub-setup", jiraSpaEntry: "async-servicedesk-knowledge-hub-setup" */ '@jira/spa-apps__servicedesk-knowledge-hub-setup/src/index.tsx'
			),
	);

const AsyncServicedeskKnowledgeHubSetup = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubSetup}
		pageId="spa-apps/servicedesk/knowledge-hub/setup"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubSetup;
